import * as client from 'lib/clients/searchPropertyAvailability';
import * as actions from 'store/propertyAvailability/propertyAvailabilityActions';
import { getPropertyId } from 'store/property/propertySelectors';
import { getQuery, getHasValidQuery } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import { getQueryParams } from 'store/router/routerSelectors';
import { getAccessToken, getFlightBookerToken, getQhUserId } from 'store/user/userSelectors';
import { setPointsTiers } from 'store/pointsConversion/pointsConversionActions';
import { createAsyncLogic } from 'lib/logic';

export const fetchPropertyAvailabilityLogic = createAsyncLogic({
  type: actions.fetchPropertyAvailability,
  latest: true,
  validate: ({ getState }, allow, reject) => {
    getHasValidQuery(getState()) ? allow() : reject();
  },
  async process({ getState }, dispatch) {
    dispatch(actions.setLoading(true));
    let propertyId;
    let query;

    const state = getState();
    propertyId = getPropertyId(state);
    query = getQuery(state);
    const queryParams = getQueryParams(state);
    const accessToken = getAccessToken(state);
    const flightBookerToken = getFlightBookerToken(state);
    const qhUserId = getQhUserId(state);

    const availabilityResponse = await client.searchPropertyAvailability({
      ...query,
      propertyId,
      accessToken,
      flightBookerToken,
      qhUserId,
    });

    const { roomTypes, meta } = availabilityResponse;
    dispatch(actions.fetchPropertyAvailabilitySuccess({ roomTypes, meta, queryParams }));
    dispatch(setPointsTiers({ ...meta.qffPointTiers }));
  },
  onError({ parsedError }, dispatch) {
    dispatch(actions.fetchPropertyAvailabilityFailure(parsedError));
  },
  onFinally(context, dispatch) {
    dispatch(actions.setLoading(false));
  },
});
